import { Modal, ModalBody } from "@mantine/core"

const MantineBody = ({ children }: any) => {
    return (
        <ModalBody>{children}</ModalBody>
    )
}

const MantineModal = (props: any) => {
    const { children, opened, onClose, title, centered, size, className } = props
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={title}
            centered={centered || false}
            size={size}
            withCloseButton={false}
            className={className}
        >
            {children}
        </Modal>
    )
}
export { MantineModal, MantineBody }
